export const SECOND_IN_MS = 1000

export const MINUTE_IN_MS = SECOND_IN_MS * 60

export const HOUR_IN_MS = MINUTE_IN_MS * 60

export const DAY_IN_MS = HOUR_IN_MS * 24

export const isSameDate = (firstDate: Date, secondDate: Date) => {
	const firstDateDay = firstDate.getDate()
	const firstDateMonth = firstDate.getMonth()
	const firstDateYear = firstDate.getFullYear()

	const secondDateDay = secondDate.getDate()
	const secondDateMonth = secondDate.getMonth()
	const secondDateYear = secondDate.getFullYear()

	const isSameDay = firstDateDay === secondDateDay
	const isSameMonth = firstDateMonth === secondDateMonth
	const isSameYear = firstDateYear === secondDateYear

	const isSameDate = isSameDay && isSameMonth && isSameYear

	return isSameDate
}

export const isSameTimestamp = (firstDate: Date, secondDate: Date) => {
	const firstTimestamp = +firstDate
	const secondTimestamp = +secondDate

	const isSameTimestamp = firstTimestamp === secondTimestamp

	return isSameTimestamp
}

export const formatDateInHours = (date: Date) => {
	const hours = date.getHours()
	const minutes = date.getMinutes()

	const formattedHours = String(hours).length === 1 ? `0${hours}` : hours
	const formattedMinutes = String(minutes).length === 1 ? `0${minutes}` : minutes

	const formattedDateInHours = `${formattedHours}:${formattedMinutes}`

	return formattedDateInHours
}

export const formatDateInBrazilianDate = (date: Date) => {
	const day = date.getDate()
	const month = date.getMonth() + 1
	const year = date.getFullYear()

	const formattedDay = day < 10 ? `0${day}` : day
	const formattedMonth = month < 10 ? `0${month}` : month

	const formattedDateInBrazilianDate = `${formattedDay}/${formattedMonth}/${year}`

	return formattedDateInBrazilianDate
}

export const getBrazilianWeekDay = (date: Date) => {
	const weekDay = date.getDay()

	const brazilianWeekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]

	return brazilianWeekDays[weekDay]
}

export const secondsToTime = (expectedSeconds: number) => {
	const hours = Math.floor(expectedSeconds / (60 * 60))

	const minutesDivisor = expectedSeconds % (60 * 60)
	const minutes = Math.floor(minutesDivisor / 60)

	const secondsDivisor = minutesDivisor % 60
	const seconds = Math.ceil(secondsDivisor)

	return {
		hours,
		minutes,
		seconds
	}
}

export const hasMoreThanDays = (date: Date, moreThanDays: number): boolean => {
	const today = new Date()
	const weekInMilliseconds = 1000 * 60 * 60 * 24 * (moreThanDays)
	return (today.getTime() - date.getTime()) > weekInMilliseconds
}

export const hasMoreThanAWeek = (date: Date): boolean => {
	return hasMoreThanDays(date, 7)
}

export const formatMessageDate = (date: Date) => {
	const formattedDateInHours = formatDateInHours(date)

	if (hasMoreThanAWeek(date)) {
		const formattedDate = formatDateInBrazilianDate(date)
		const dateWithTwoYearNumbers = formattedDate.slice(0, 6) + formattedDate.slice(8, 10)
		return `${dateWithTwoYearNumbers} - ${formattedDateInHours}`
	} else {
		const formattedDateInBrazilianWeekDay = getBrazilianWeekDay(date)

		const formattedMessageDate = `${formattedDateInBrazilianWeekDay} - ${formattedDateInHours}`
		return formattedMessageDate
	}
}

export const isToday = (someDate: Date) => {
	const today = new Date()
	return someDate.getDate() === today.getDate() &&
		someDate.getMonth() === today.getMonth() &&
		someDate.getFullYear() === today.getFullYear()
}

export const isYesterday = (someDate: Date) => {
	const today = new Date()
	return someDate.getDate() === today.getDate() - 1 &&
		someDate.getMonth() === today.getMonth() &&
		someDate.getFullYear() === today.getFullYear()
}

export const getFormattedCounterTime = (counterTime: number) => {
	const time = secondsToTime(counterTime)

	const formattedMinutes = time.minutes < 10 ? `0${time.minutes}` : time.minutes
	const formattedSeconds = time.seconds < 10 ? `0${time.seconds}` : time.seconds

	const formattedTime = `${formattedMinutes}:${formattedSeconds}`

	return formattedTime
}

export const timeout = async (milliseconds: number): Promise<void> => {
	await new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const fullDatetime = (date: Date) => {
	return `${formatDateInBrazilianDate(date)} às ${formatDateInHours(date)}`
}

export const translatedDaysOfWeek: Record<number, string> = {
	0: "Domingo",
	1: "Segunda",
	2: "Terça",
	3: "Quarta",
	4: "Quinta",
	5: "Sexta",
	6: "Sábado"
}

/**
 * Turns time in 'hh:mm' to Date.
 */
export const transformHourAndMinutesToDate = (hourAndMinutes: string) => {
	const pieces = hourAndMinutes?.split(":")

	if (pieces && pieces.length >= 1) {
		const hour = Number(pieces?.[0])
		const minutes = Number(pieces?.[1])

		return new Date(0, 0, 0, hour, minutes)
	}

	return null
}

export const transformDateIntoHourAndMinutes = (date: Date) => {
	const hourAndMinutes = new Intl.DateTimeFormat("pt-BR", { hour: "numeric", minute: "numeric" }).format(date)

	return hourAndMinutes
}

export const isValidDate = (date: Date) => date instanceof Date && !isNaN(Number(date))

export const getTodayIntervalDate = () => {
	const today = new Date()

	const fromDate = new Date(today)
	fromDate.setHours(0)
	fromDate.setMinutes(0)
	fromDate.setSeconds(0)
	fromDate.setMilliseconds(0)

	const toDate = new Date(today)
	toDate.setHours(23)
	toDate.setMinutes(59)
	toDate.setSeconds(59)
	toDate.setMilliseconds(0)

	return {
		fromDate,
		toDate
	}
}
